import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH_TOKEN, AUTH_VERIFY_TOKEN } from '@/types/authTypes';

const actionTypes = [
    { type: AUTH_LOGIN, key: 'authLogin' },
    { type: AUTH_LOGOUT, key: 'authLogout' },
    { type: AUTH_REFRESH_TOKEN, key: 'authRefreshToken' },
    { type: AUTH_VERIFY_TOKEN, key: 'authVerifyToken' }
];

let initialState = actionTypes.reduce((acc, { key }) => {
    acc[key] = false;
    acc[`err${key.charAt(0).toUpperCase() + key.slice(1)}`] = false;
    return acc;
}, {});

const authSlice = (state = initialState, action) => {
    const acc = actionTypes.find((item) => item.type === action.type);
    if (!acc) return state;
    return {
        ...state,
        [acc.key]: action?.payload?.data,
        [`err${acc.key.charAt(0).toUpperCase() + acc.key.slice(1)}`]: action?.payload?.errorMessage
    };
};

export default authSlice;
